// @flow

import { onUserSetCallbackFree } from './free/on-user-set'

import type { Route, RouteComponent } from 'common/router'

let ROUTES_MAP = {
  ASSESSMENT: '/levels/primary/assessment',
  FREE: '/levels/primary/free',
  HOME: '/levels/primary',
}

if (window.location.origin.includes('.wf.foxford.ru')) {
  ROUTES_MAP = {
    ASSESSMENT: '/assessment',
    FREE: '/free',
    HOME: '/',
  }
}

export const ROUTES: Array<Route> = [
  {
    component: (): RouteComponent => import('./assessment'),
    path: ROUTES_MAP.ASSESSMENT,
    exact: true,
    componentData: {
      VISIT_TAG: { id: 349, value: 'primary | assessment' },
    },
  },
  {
    component: (): RouteComponent => import('./free'),
    path: ROUTES_MAP.FREE,
    exact: true,
    componentData: {
      onUserSetCallback: onUserSetCallbackFree,
    },
  },
  {
    component: (): RouteComponent => import('./home'),
    path: ROUTES_MAP.HOME,
    exact: true,
  },
]
